/* eslint-disable radix */
import { useState, useEffect, useContext } from 'react';
import useSWR from 'swr';
import { AppContext } from 'Context';
import { useDispatch } from 'react-redux';
import { dataFetcher, endpoints } from 'Api';
import { setDidCardAdded } from 'store/store';
import PageLayout from './components/page-layout';
import FormSection from './components/form-section';
import PaymentField from './components/payment-field';

function Page({ closeAddCard }) {
  const { setAppSnackbar, getSubscription, langText } = useContext(AppContext);
  const dispatch = useDispatch();
  const addCardText = langText?.settings?.billPayment?.paymentMethod?.cardDetails;
  const [cardNumber, setCardNumber] = useState(undefined);
  const [expirationDate, setExpirationDate] = useState(undefined);
  const [cvvNumber, setCvvNumber] = useState(undefined);
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [paymentIsValid, setPaymentValidity] = useState(false);

  const { isValidating: addingCard, mutate: addCard } = useSWR([
    endpoints.addPaymentMethods, cardNumber, expirationDate?.split('/')[0], expirationDate?.split('/')[1], cvvNumber], {
    fetcher: (url, number, exp_month, exp_year, cvc) => dataFetcher(url, { number, exp_month, exp_year, cvc }),
    onSuccess: ({ success, message }) => {
      if (success) {
        getSubscription();
        closeAddCard();
        setAppSnackbar({
          isVisible: true, type: 'success', message: 'New card added successfully' });
          dispatch(setDidCardAdded(true));
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message,
        });
      }
    },
    onError: (error) => {
      const responseData = error?.response?.data;
      setAppSnackbar({ isVisible: true, type: 'error', message: responseData?.message });
    },
  });
  useEffect(() => {
    if (paymentIsValid) {
      setIsFormFilled(true);
    }
  }, [paymentIsValid]);

  return (
    <PageLayout
      continueButtonText={addingCard ? 'Adding card' : (addCardText?.addButton || 'Add card')}
      formIsFilled={isFormFilled}
      onContinue={() => {
        addCard();
      }}
      handleClose={closeAddCard}
      subTitle=""
      title={addCardText?.title || 'Enter card details'}
      addingCard={addingCard}
    >
      <FormSection title={addCardText?.description || 'Payment Information'}>
        <PaymentField
          onCardNumberChange={setCardNumber}
          onCvvNumberChange={setCvvNumber}
          onExpirationDateChange={setExpirationDate}
          setValidity={setPaymentValidity}
        />
      </FormSection>
    </PageLayout>
  );
}

export default Page;
